import { render, staticRenderFns } from "./ToolbarTextareaColor.vue?vue&type=template&id=8c1b6d46"
import script from "./ToolbarTextareaColor.vue?vue&type=script&lang=js"
export * from "./ToolbarTextareaColor.vue?vue&type=script&lang=js"
import style0 from "./ToolbarTextareaColor.vue?vue&type=style&index=0&id=8c1b6d46&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports